import React from 'react';
import { Stack, Text } from '@fluentui/react';
import { IC } from 'components/SVGIcon';
import { EditIcon } from 'kits/IconKit2';
import { getTextColorForBackground } from 'kits/colorKit';

interface Props {
    showTopic: boolean;
    topic: string;
    showIconOnHover: boolean;
    setShowIconOnHover: (v: boolean) => void;
    setShowCallOut: (v: boolean) => void;
    setToggleSetTopicDialog: (v: boolean) => void;
    localProfile: any;
    bgColor?: string;
    isSmallDevice: boolean;
    isSmallLaptop: boolean;
}

const TopicDisplay: React.FC<Props> = ({
    showTopic,
    topic,
    showIconOnHover,
    setShowIconOnHover,
    setShowCallOut,
    setToggleSetTopicDialog,
    localProfile,
    bgColor,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isSmallDevice,
    isSmallLaptop
}) => {
    if (!showTopic && !topic) return null;

    const isVisitor = ['visitor', 'auto-confirmed-visitor'].includes(localProfile?.type);
    const textColor = bgColor ? getTextColorForBackground(bgColor) : 'white';

    const handleClick = () => {
        if (!isVisitor) setToggleSetTopicDialog(false);
    };

    return (
        <Stack
            style={{
                backgroundColor: bgColor,
                color: textColor,
                cursor: isSmallLaptop ? 'default' : 'pointer',
                padding: '5px 10px',
                width: '100%',
                height: 'auto'
            }}
            horizontalAlign="center"
            verticalAlign="center"
            onClick={!isSmallLaptop ? handleClick : undefined}
            onMouseEnter={() => {
                if (!isVisitor) {
                    setShowIconOnHover(true);
                    setTimeout(() => setShowCallOut(true), 300);
                }
            }}
            onMouseLeave={() => {
                if (!isVisitor) {
                    setShowIconOnHover(false);
                    setShowCallOut(false);
                }
            }}
        >
            <Stack horizontal style={{ width: '100%' }} horizontalAlign="center">
                {showIconOnHover && (
                    <IC variant="custom" size={15} iconColor={textColor}>
                        <EditIcon />
                    </IC>
                )}
                <Text
                    variant="medium"
                    style={{
                        fontWeight: 'bold',
                        marginLeft: showIconOnHover ? 5 : 0,
                        color: 'inherit',
                        textAlign: 'center',
                        width: '95%'
                    }}
                >
                    {topic}
                </Text>
            </Stack>
        </Stack>
    );
};

export default TopicDisplay;
